import { observer } from 'mobx-react-lite';
import { useChapterStore } from './provider/ChapterProvider';

const ChapterDetailTitle = observer(() => {
    const chapterStore = useChapterStore();

    return (
        <div>
            <div className="text-base-content/50 text-sm font-semibold">
                챕터 {chapterStore.chapter?.num || ''}
            </div>
            {chapterStore.chapter ? (
                <>
                    <div className="mt-1 h-6 text-lg font-semibold">
                        {chapterStore.chapter.title}
                    </div>
                    <div className="text-base-content/70 mt-0.5 h-5 text-sm">
                        {chapterStore.chapter.titleKo}
                    </div>
                </>
            ) : (
                <>
                    <div className="skeleton mt-1 h-6 w-1/2 rounded"></div>
                    <div className="skeleton mt-0.5 h-5 w-1/3 rounded"></div>
                </>
            )}
        </div>
    );
});

export default ChapterDetailTitle;
